
import api from '../../api/index.js'

const state = {

}

const getters = {

}

const actions = {
    // 获取搜索集合
    getSearchMemorialHallList({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/Search/GetMemorialHallList',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
}

const mutations = {

}

export default {
    state,
    getters,
    actions,
    mutations
}
